module.exports = __webpack_public_path__ + "img/violet_075.fd2a719a.png";